module.exports = function(vars) {
var __t, __p = '';
__p += '<li class="toolIconAudioOnly"><span class="tooltipLeft ico action-toggle-audioOnly"\n  title="Toggle Audio-Only Mode" data-title="Toggle Audio Only Mode" aria-label="Toggle Audio Only Mode"><i class="fa fa-headphones"></i></span></li>\n';
return __p
}


// WEBPACK FOOTER //
// ./src/templates/audioOnlyToolBoxIcon.ejs